/* Instant category navigation (demo): swaps the collection area in place
   instead of a full page reload. Loaded only when the "Instant category
   navigation" section setting is enabled. */
(function () {
  if (!window.fetch || !window.history.pushState || !window.DOMParser) return;
  if (!document.querySelector('.collection-layout')) return;
  var busy = false;

  function targetUrl(href) {
    if (!href) return null;
    var u;
    try { u = new URL(href, location.origin); } catch (err) { return null; }
    if (u.origin !== location.origin || u.pathname.indexOf('/collections/') !== 0) return null;
    if (u.pathname.indexOf('/products/') !== -1) return null;
    if (!u.searchParams.has('sort_by') && u.pathname.indexOf('rebuild-services') === -1) {
      u.searchParams.set('sort_by', 'title-ascending');
    }
    return u;
  }

  /* hover prefetch: start downloading the page before the click lands */
  var prefetched = {};
  function prefetch(url) {
    var key = url.toString();
    if (!prefetched[key]) {
      prefetched[key] = fetch(key).then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); });
      prefetched[key].catch(function () { delete prefetched[key]; });
    }
    return prefetched[key];
  }

  function bindSort(scope) {
    scope.querySelectorAll('[data-sort-select]').forEach(function (sel) {
      if (sel.dataset.instantBound) return;
      sel.dataset.instantBound = '1';
      sel.addEventListener('change', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', sel.value);
        swap(u, true);
      });
    });
  }

  function swap(url, push) {
    if (busy) return;
    busy = true;
    var layout = document.querySelector('.collection-layout');
    if (layout) layout.classList.add('is-loading');
    prefetch(url)
      .then(function (html) {
        delete prefetched[url.toString()];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('.collection-layout');
        var current = document.querySelector('.collection-layout');
        if (!next || !current) { location.href = url.toString(); return; }
        current.replaceWith(next);
        /* re-run inline scripts (sidebar expand/collapse) in the new markup */
        next.querySelectorAll('script:not([src])').forEach(function (old) {
          var s = document.createElement('script');
          s.textContent = old.textContent;
          old.replaceWith(s);
        });
        bindSort(next);
        /* update the URL first — scripts reacting to the swap event read
           window.location to decide fitment/filter behaviour */
        if (push) history.pushState({ qpInstant: true }, '', url.toString());
        if (doc.title) document.title = doc.title;
        /* let other scripts (wishlist hearts, fitment badges) re-initialize
           against the swapped-in markup */
        window.dispatchEvent(new CustomEvent('qjp:page-swapped'));
        window.scrollTo({ top: 0, behavior: 'auto' });
      })
      .catch(function () { location.href = url.toString(); })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || !document.querySelector('.collection-layout')) return;
    var url = targetUrl(a.getAttribute('href'));
    if (!url) return;
    e.preventDefault();
    swap(url, true);
  });

  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank') return;
    var url = targetUrl(a.getAttribute('href'));
    if (url) prefetch(url);
  });

  window.addEventListener('popstate', function () {
    if (location.pathname.indexOf('/collections/') === 0 && document.querySelector('.collection-layout')) {
      swap(new URL(location.href), false);
    }
  });

  bindSort(document);
})();
